<form [formGroup]="form" class="needs-validation">
  <input
    formControlName="id"
    name="id"
    type="text"
    class="form-control"
    required
    style="display: none"
  />

  <div class="position-relative row mb-1 pb-1 form-group">
    <label for="name_Id" class="col-sm-2 col-form-label"
      >{{ "Form.NAME" | translate }} <span class="text-danger">*</span></label
    >
    <div class="col-sm-10">
      <input
        formControlName="name"
        placeholder="{{ 'Form.WorkflowName' | translate }}"
        name="name"
        id="name_Id"
        type="text"
        class="form-control"
        required
      />
      <div *ngIf="submitted && f.name.errors" class="invalid-feedback">
        <div *ngIf="f.name.errors.required">
          {{ "Form.Error.NAME" | translate }}
        </div>
      </div>
    </div>
  </div>

  <div class="position-relative row mb-1 pb-1 form-group">
    <label for="elementSelector" class="col-sm-2 col-form-label">{{
      "Form.ElementSelector" | translate
    }}</label>
    <div class="col-sm-10">
      <select
        id="elementSelector"
        class="form-control"
        name="elementSelector"
        formControlName="elementSelector"
      >
        <option value="">Select Element Identifier</option>
        <option value="Id">Id</option>
        <option value="Class">Class</option>
        <option value="Path">Path</option>
        <option value="Name">Name</option>
        <option value="TagName">Tag Name</option>
        <option value="XPath">XPath</option>
      </select>
    </div>
  </div>

  <div class="position-relative row mb-1 pb-1 form-group">
    <label for="triggerElement" class="col-sm-2 col-form-label">{{
      "Form.Element" | translate
    }}</label>
    <div class="col-sm-10">
      <input
        formControlName="triggerElement"
        placeholder="{{ 'Form.Element' | translate }}"
        name="triggerElement"
        id="triggerElement"
        type="text"
        class="form-control"
      />
    </div>
  </div>

  <div
    class="position-relative mb-1 pb-1 row form-group"
    *ngIf="currentTooltip.screenType != 'generic'"
  >
    <label class="col-sm-2 col-form-label" for="screenType"
      >{{ "Form.screenType" | translate }}
    </label>
    <div class="col-sm-10">
      <div class="custom-radio custom-control">
        <input
          class="custom-control-input"
          id="screenSpecific"
          name="screenType"
          type="radio"
          value="screenSpecific"
          formControlName="screenType"
        />
        <label class="custom-control-label" for="screenSpecific">{{
          "Form.screenSpecific" | translate
        }}</label>
      </div>

      <div class="custom-radio custom-control">
        <input
          class="custom-control-input"
          id="generic"
          name="screenType"
          type="radio"
          value="generic"
          formControlName="screenType"
        />
        <label class="custom-control-label" for="generic">{{
          "Form.generic" | translate
        }}</label>
      </div>
    </div>
  </div>

  <div class="position-relative row mb-1 pb-1 form-group">
    <label class="col-sm-2 col-form-label" for="showOnElement"
      >{{ "Form.ShowOn" | translate }}
    </label>
    <div class="col-sm-10">
      <div class="custom-radio custom-control">
        <input
          class="custom-control-input"
          id="click"
          name="showOn"
          type="radio"
          value="click"
          formControlName="showOn"
        />
        <label class="custom-control-label" for="click">{{
          "Form.Click" | translate
        }}</label>
      </div>

      <div class="custom-radio custom-control">
        <input
          class="custom-control-input"
          id="Hover"
          name="showOn"
          type="radio"
          value="hover"
          formControlName="showOn"
        />
        <label class="custom-control-label" for="Hover">{{
          "Form.Hover" | translate
        }}</label>
      </div>

      <div class="custom-radio custom-control">
        <input
          class="custom-control-input"
          id="icon"
          name="showOn"
          type="radio"
          value="icon"
          formControlName="showOn"
        />
        <label class="custom-control-label" for="icon">{{
          "Form.Icon" | translate
        }}</label>
      </div>
    </div>
  </div>

  <div class="position-relative mb-1 pb-1 row form-group">
    <label class="col-sm-2 col-form-label" for="feedbackElement"
      >{{ "Form.feedback" | translate }}
    </label>
    <div class="col-sm-10">
      <div class="custom-radio custom-control">
        <input
          class="custom-control-input"
          id="on"
          name="feedback"
          type="radio"
          value="on"
          formControlName="feedback"
        />
        <label class="custom-control-label" for="on">{{
          "Form.On" | translate
        }}</label>
      </div>

      <div class="custom-radio custom-control">
        <input
          class="custom-control-input"
          id="off"
          name="feedback"
          type="radio"
          value="off"
          formControlName="feedback"
        />
        <label class="custom-control-label" for="off">{{
          "Form.Off" | translate
        }}</label>
      </div>

      <div class="custom-radio custom-control">
        <input
          class="custom-control-input"
          id="default"
          name="feedback"
          type="radio"
          value="default"
          formControlName="feedback"
        />
        <label class="custom-control-label" for="default">{{
          "Form.asdefaultconfig" | translate
        }}</label>
      </div>
    </div>
  </div>

  <div
    class="position-relative row form-group"
    *ngIf="form.get('showOn').value === 'icon'"
  >
    <label class="col-sm-2 col-form-label" for="iconTypeElement">
      {{ "Form.IconType" | translate }}
    </label>
    <div class="col-sm-10">
      <select
        id="icon-type"
        class="form-control"
        name="iconType"
        formControlName="iconType"
      >
        <option value="Info">{{ "Form.Info" | translate }}</option>
        <option value="QuestionMark">
          {{ "Form.QuestiionMark" | translate }}
        </option>
      </select>
    </div>
  </div>

  <div
    class="position-relative row form-group"
    *ngIf="form.get('showOn').value === 'icon'"
  >
    <label class="col-sm-2 col-form-label" for="iconStyle">
      {{ "Form.IconStyle" | translate }}
    </label>
    <div class="col-sm-10">
      <textarea
        id="icon-style"
        placeholder="{{ 'Form.IconStyle' | translate }}"
        class="form-control"
        rows="4"
        cols="50"
        name="style"
        formControlName="style"
      >
      </textarea>
    </div>
  </div>

  <div class="position-relative row form-group">
    <label for="AllowUserToSkipOnDevice" class="col-sm-2 col-form-label"
      >{{ "Form.AllowUserToSkipOnDevice" | translate }}
    </label>
    <div class="col-sm-10">
      <input
        type="checkbox"
        id="AllowUserToSkipOnDevice"
        name="AllowUserToSkipOnDevice"
        formControlName="allowSkipOnDevice"
        class="form-check-input"
        style="margin: 10px 0"
        [ngClass]="{
          'checked-box': form.get('allowSkipOnDevice')?.value
        }"
      />
    </div>
  </div>

  <div class="position-relative row form-group">
    <label for="position" class="col-sm-2 col-form-label">
      {{ "Form.SRoles" | translate }}
    </label>
    <ng-select
      [items]="roles"
      [virtualScroll]="true"
      bindLabel="displayname"
      bindValue="name"
      placeholder="{{ 'Form.SRoles' | translate }}"
      class="ms-1 col-4"
      [multiple]="true"
      formControlName="roles"
    >
    </ng-select>
  </div>
</form>
<!-- [(ngModel)]="currentTooltip.roles" -->
<div class="d-flex justify-content-end">
  <button
    *ngIf="addWorkflow"
    class="btn mb-2 pb-2 btn-primary"
    style="margin-left: auto; margin-right: 0.3rem"
    (click)="saveWorkflow()"
  >
    Save & Add Step
  </button>
</div>
<div class="card-header" *ngIf="!addStep && !addWorkflow">
  {{ "Form.Steps" | translate }}
  <button
    *ngIf="!addStep"
    class="btn btn-primary"
    style="margin-left: auto; margin-right: 0.3rem"
    (click)="addWorkflowVisible(true)"
  >
    {{ "Form.AddSteps" | translate }}
  </button>
  <button
    *ngIf="addStep"
    class="btn btn-secondary"
    style="margin-left: auto; margin-right: 0.3rem"
    (click)="addWorkflowVisible(false)"
  >
    {{ "Form.CANCEL" | translate }}
  </button>
</div>

<div class="col-md-12 col-xl-12 mt-10" style="margin-top: 30px" *ngIf="addStep">
  <app-dynamic-workflow-step-form
    [workflowDetails]="form.value"
    (formSubmitted)="onFormSubmitted(stepDetails)"
    [project]="project"
    [screen]="screen"
    [addStep]="'true'"
    [availableRoles]="roles"
    [currentWorkflow]="currentTooltip"
    (onLanguageChange)="onSelectedWorkflowLanguageChange($event)"
    (onStepSubmit)="recieveResfromWFS($event)"
  ></app-dynamic-workflow-step-form>
</div>

<div
  ngbAccordion
  #accordion="ngbAccordion"
  class="col-12 px-0 mx-auto mb-3 bg-white"
>
  <div
    ngbAccordionItem
    *ngFor="let workflowStep of workflowSteps"
    [collapsed]="true"
    id="workflowStep.id"
  >
    <h2 ngbAccordionHeader class="card-header white w-100">
      <button
        ngbAccordionButton
        ngbPanelToggle
        class="no-after-icon"
        style="
          border: none !important;
          width: 100% !important;
          height: 100% !important;
          background-color: transparent !important;
          cursor: pointer;
        "
      >
        <!-- <div class=""> -->
        <div
          class="btn btn-link col-12 p-0 d-flex justify-content-between align-items-center"
        >
          <span class="text-start">
            <h5 class="m-0 font-weight-bold card-title">
              {{ workflowStep.name }}:
              {{ getSelectedWorkflowStepLanguage(workflowStep.id) }}
            </h5>
          </span>
          <span
            class="text-end"
            (click)="deleteStep(workflowStep); $event.stopPropagation()"
            style="cursor: pointer"
          >
            <i class="fa fa-trash-o text-danger" aria-hidden="true"></i>
          </span>
        </div>
        <!-- </div> -->
      </button>
    </h2>
    <div ngbAccordionCollapse>
      <div ngbAccordionBody class="bg-white">
        <div id="tooltip-global-config-id" style="margin: 0px 10px">
          <div class="form-validation">
            <app-dynamic-workflow-step-form
              (formSubmitted)="onFormSubmitted(workflowStep)"
              [screen]="screen"
              [workflowStep]="workflowStep"
              [project]="project"
              [currentWorkflow]="currentTooltip"
              (onLanguageChange)="onSelectedWorkflowLanguageChange($event)"
              (onStepSubmit)="recieveResfromWFS(step)"
              [isLanguageChanged]="isLanguageChanged"
              [languageId]="languageId"
              [dataSignal]="dataSignal"
            ></app-dynamic-workflow-step-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="divider"></div>

<div class="position-relative row form-check">
  <div class="col-sm-10 offset-sm-2 m-0 p-0">
    <button
      class="btn"
      style="margin-right: 10px"
      type="submit"
      [ngClass]="{
        'btn-primary': form.dirty,
        'btn-secondary': !form.dirty
      }"
      [disabled]="!form.dirty"
      (click)="onSubmit()"
    >
      {{ "Form.PublishToDev" | translate }}
    </button>
    <button
      class="btn reset-btn text-white"
      [disabled]="!form.dirty"
      (click)="onReset()"
    >
      {{ "Form.CANCEL" | translate }}
    </button>
    <button
      class="btn"
      style="margin-right: 10px; margin-left: 10px"
      [ngClass]="{
        'btn-primary': !form.dirty && publishToQA,
        'btn-secondary': form.dirty || !publishToQA
      }"
      [disabled]="form.dirty || !publishToQA"
      (click)="onClickOfPublish('qa'); form.markAsPristine()"
    >
      {{ "Form.PublishToQA" | translate }}
    </button>
    <button
      class="btn"
      [ngClass]="{
        'btn-primary': (!form.dirty || publishToProd) && !publishToQA,
        'btn-secondary': form.dirty || !publishToProd
      }"
      [disabled]="form.dirty || !publishToProd"
      (click)="onClickOfPublish('prod')"
    >
      {{ "Form.PublishToProd" | translate }}
    </button>
  </div>
</div>
<!-- <div *ngIf="isLoading" class="loaderdata">
  <div class="spinner-border" role="status">
    <span class="sr-only">{{ "Form.Loading" | translate }}</span>
  </div>
</div> -->
